module.exports = __webpack_public_path__ + "static/media/settings.d8e759bc.svg";